





























import { Vue, Component, Prop } from "vue-property-decorator";
import MD5 from "crypto-js/md5";

@Component
export default class Avatar extends Vue {
  // Props

  @Prop({ default: null })
  public src!: string;

  @Prop({ default: null })
  public name!: string;

  @Prop({ default: "" })
  public email!: string;

  @Prop({ default: 100 })
  public size!: number;

  // Data

  public imgAlt = "";

  // Computed

  public get initials() {
    const name = (this.name || "")
      .replace(/[^A-Z\s]/gi, "")
      .trim()
      .split(" ");
    if (name.length > 1) {
      const first = this.$_.first(this.$_.first(name)) || "";
      const last = this.$_.first(this.$_.last(name)) || "";
      return `${first + last}`.toUpperCase();
    }
    return name[0].substring(0, 2).toUpperCase();
  }

  public get gravatarSrc() {
    const hash = MD5(this.email).toString();
    return `https://gravatar.com/avatar/${hash}?d=blank&s=200`;
  }

  public get isNativeSrc() {
    return !this.src.includes("gravatar.com");
  }

  // Methods

  public handleLoadEvent() {
    this.imgAlt = this.name;
  }
}
